import { DecimalPipe } from '@angular/common';
import { ColumnOutputType } from 'app/component-library/table/column-output-type';
import { CONFIG } from 'app/core/config';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { DisplayData } from '../bar/DisplayData';
import { PlannedMaintenanceImprovements } from '../widget-parameters/planned-maintenance-improvements.enum';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { ItemizedWidgetData } from './itemized-widget-data';

export class PlannedMaintenanceImprovementsItemizedWidgetData extends ItemizedWidgetData {
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }

  public setFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(w => w.valueSource === ValueSource.PlannedMaintenanceImprovements);

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (!reset && widgetParam.valueSource === ValueSource.PlannedMaintenanceImprovements) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createColumns(): TableColumn[] {
    const assetNameColumn = new TableColumn('Asset/Optimization Name', 'AssetName');
    assetNameColumn.outputType = ColumnOutputType.Link;
    assetNameColumn.linkClickEvent = this.navigateToOptimizationPage;

    const currentColumn = new TableColumn('Current (months)', 'CurrentInterval');
    currentColumn.formatterPipe = DecimalPipe;
    currentColumn.formatterPipeArgs = ['1.2-2'];
    const optimisedColumn = new TableColumn('Optimised (months)', 'OptimisedInterval');
    optimisedColumn.formatterPipe = DecimalPipe;
    optimisedColumn.formatterPipeArgs = ['1.2-2'];
    const selectedColumn = new TableColumn('Selected (months)', 'SelectedInterval');
    selectedColumn.formatterPipe = DecimalPipe;
    selectedColumn.formatterPipeArgs = ['1.2-2'];

    return [assetNameColumn, currentColumn, optimisedColumn, selectedColumn];
  }

  public createOverallTableHeaderColumn(): TableColumn {
    const headerColumn = new TableColumn('', 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.improvementsDrillDown;
    return headerColumn;
  }

  private improvementsDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.PlannedMaintenanceImprovements;
    widgetParam.valueType = ValueType.Int;
    widgetParam.displayName = data.label;
    widgetParam.intValue = -1;

    if (data.label === 'Increased Maintenance Interval') {
      widgetParam.intValue = PlannedMaintenanceImprovements.Increased;
    } else if (data.label === 'Validated Maintenance Interval') {
      widgetParam.intValue = PlannedMaintenanceImprovements.Validated;
    } else if (data.label === 'Reduced Maintenance Interval') {
      widgetParam.intValue = PlannedMaintenanceImprovements.Reduced;
    } else {
      widgetParam.intValue = -1;
    }

    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  private navigateToOptimizationPage = (data: any) => {
    if (data.AdHocOptimizationId) {
      this.router.navigate([this.authService.urlCatalog + CONFIG.routes.mo.maintenanceOptimizationAdHoc], { queryParams: { analysisId: data.AdHocOptimizationId } });
    } else {
      if (data.AnalysisId && data.OrgTreeNodeId && data.OrgTreeNodeId !== CONFIG.constants.emptyGuid) {
        this.router.navigate([this.authService.urlCatalog + CONFIG.routes.mo.maintenanceOptimizationAnalysis], {
          queryParams: { itemId: data.OrgTreeNodeId, analysisId: data.AnalysisId },
        });
      }
    }
  };
}
